module.exports = __webpack_public_path__ + "static/media/clock.6a5f1f59.svg";